import React, { useEffect, useRef, useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { MapPin, ExternalLink, ParkingCircle, Calendar } from 'lucide-react';

const LocationSection = () => {
  const sectionRef = useRef(null);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleGetDirections = () => {
    window.open('https://maps.google.com/?q=Av.+del+Libertador+101+Vicente+Lopez+Buenos+Aires', '_blank');
  };

  return (
    <section id="ubicacion" className="py-24 bg-white relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div 
          className="absolute top-0 left-0 w-96 h-96 bg-orange-300/30 rounded-full blur-3xl"
          style={{ transform: `translateY(${(scrollY - 3000) * 0.2}px)` }}
        ></div>
        <div 
          className="absolute bottom-0 right-0 w-96 h-96 bg-pink-300/30 rounded-full blur-3xl"
          style={{ transform: `translateY(${(scrollY - 3000) * -0.15}px)` }}
        ></div>
      </div>

      <div ref={sectionRef} className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 opacity-0">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6">
            Ubicación
          </h2>

          {/* Place info block */}
          <div className="space-y-2 max-w-2xl mx-auto">
            <p className="text-2xl sm:text-3xl font-bold text-slate-900">
              El Cubo Eventos
            </p>
            <div className="flex items-center justify-center gap-2 text-slate-700">
              <MapPin className="w-5 h-5 text-orange-600 flex-shrink-0" />
              <p className="text-base sm:text-lg">Av. del Libertador 101, Vicente López</p>
            </div>
            <div className="flex items-center justify-center gap-2 text-slate-700">
              <Calendar className="w-5 h-5 text-pink-600 flex-shrink-0" />
              <p className="text-base sm:text-lg">Jueves 3 de septiembre · Desde las 9:30 hs</p>
            </div>
          </div>
        </div>

        {/* Parking Info */}
        <div className="mb-10 max-w-2xl mx-auto">
          <div className="bg-gradient-to-r from-orange-500 to-pink-500 rounded-2xl p-1 shadow-xl">
            <div className="bg-white rounded-2xl p-6 sm:p-8 text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-orange-500 to-pink-500 rounded-full mb-4 shadow-lg">
                <ParkingCircle className="w-12 h-12 text-white" strokeWidth={2.5} />
              </div>
              <h3 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-2">
                Estacionamiento gratuito
              </h3>
              <p className="text-lg text-slate-700 mb-1">
                Subsuelo del complejo
              </p>
              <p className="text-base text-slate-700 mb-2">
                Se deberá indicar que vienen a Elit Brand Tour.
              </p>
              <p className="text-sm text-slate-500 italic">
                * Cupos limitados
              </p>
            </div>
          </div>
        </div>

        {/* Map */}
        <Card className="border-orange-200 shadow-xl overflow-hidden mb-8">
          <CardContent className="p-0">
            <div className="relative w-full h-96">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3287.4697937282595!2d-58.47963492429713!3d-34.53144845431029!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb43f0c999999%3A0x1234567890abcdef!2sVicente%20L%C3%B3pez%2C%20Buenos%20Aires!5e0!3m2!1ses!2sar!4v1234567890123!5m2!1ses!2sar"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Mapa de ubicación"
              ></iframe>
            </div>
          </CardContent>
        </Card>

        {/* Cómo llegar button */}
        <div className="text-center">
          <Button
            onClick={handleGetDirections}
            className="bg-gradient-to-r from-orange-600 to-pink-600 hover:from-orange-700 hover:to-pink-700 text-white px-8 py-6 text-lg rounded-full transition-all duration-300 hover:scale-105 shadow-lg"
          >
            Cómo llegar
            <ExternalLink className="ml-2 w-5 h-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
